import { HttpInterceptorFn, HttpRequest, HttpHandlerFn, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, switchMap, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { inject } from '@angular/core';
import { UserStore } from 'src/app/core/stores/user.store';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { buildSignInQueryParams } from 'src/app/core/utils/auth/return-url.utils';

export const authInterceptor: HttpInterceptorFn = (
  request: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const location = inject(Location);

  const addToken = (req: HttpRequest<unknown>): HttpRequest<unknown> => {
    const token = userStore.accessToken();

    if (token) {
      return req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`,
        },
      });
    }
    return req;
  };

  const handleUnauthorizedError = (
    req: HttpRequest<unknown>,
    nextFn: HttpHandlerFn
  ): Observable<HttpEvent<unknown>> => {
    return userStore.getRefreshToken().pipe(
      switchMap(tokens => {
        const newRequest = req.clone({
          setHeaders: {
            Authorization: `Bearer ${tokens.access_token}`,
          },
        });

        return nextFn(newRequest);
      }),
      catchError((error: HttpErrorResponse) => {
        router.navigate(['/auth/sign-in'], { queryParams: buildSignInQueryParams(location.path()) });
        throw error;
      })
    );
  };

  const authReq = addToken(request);

  return next(authReq).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !request.url.includes('/jwt/refresh')) {
        return handleUnauthorizedError(request, next);
      }
      return throwError(() => error);
    })
  );
};
